import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Home from './Home';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message,
  } = state.request;
  return {
    isLoading,
    data,
    error,
    message,
  };
}

const Styled = withStyles(styles)(Home);

export default connect(
  mapStateToProps,
)(Styled);
